export default [
    {
        path: '/roles',
        name: 'rolesList',
        component: () => import('../views/List.vue')
    },
    {
        path: '/roles/create',
        name: 'rolesCreate',
        component: () => import('../views/Form.vue')
    },
    {
        path: '/roles/:id/edit',
        name: 'rolesEdit',
        component: () => import('../views/Form.vue')
    },
]